<template>
  <div v-if="localSelectChat===null" class="text-center mt-10">
    <alert>Чат не выбран</alert>
  </div>
  <div v-else>
    <v-toolbar dense flat>
      <div>Участники</div>
      <v-spacer/>
      <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-divider/>
  </div>
</template>

<script>
import Alert from "../../../componentsV2/base/Alert.vue";

export default {
  components: {Alert},
  props: ['height','cats','selectChat'],
  data: () => ({
    localSelectChat:null,
  }),
  mounted() {
    this.localSelectChat = this.selectChat;
  },
  watch: {
    selectChat(){this.localSelectChat = this.selectChat},
    localSelectChat(){this.$emit('update:selectChat', this.localSelectChat)},
  },
  computed:{
    cat(){
      let arr = this.cats.filter(v=>v.id===this.localSelectChat.cat)
      return arr.length>0 ? arr[0] : null;
    },
    phones(){
      return this.localSelectChat.dialogUsers
          .filter(v=>v.user===null || v.user.id!==this.$store.state.user.id)
          .map(v=>v.phone)
    }
  },
  methods:{

  }
}
</script>